import React, { useState } from "react";
// import { CircularProgressbar } from "react-circular-progressbar";
// import "react-circular-progressbar/dist/styles.css";
// import axios from "../../../../HOC/CreateAxios/CreateAxios";
// import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
// import storage from "../../../../HOC/FIREBASE/FIREBASE";
// import { ToastContainer, toast } from "react-toastify";
import ContextApi from "../../HOC/ContextApi/ContextApi";
import WithdrawUSDTTable from "../../components/pageComponents/WithdrawReport/WithdrawUSDT_Table";
import WithdrawBankTable from "../../components/pageComponents/WithdrawReport/WithdrawBank_Table";
function WithDrawReport() {
  // const [message, setMessage] = useState(false);
  // const [modelClick, setModelClick] = useState(false);

  // const [counter, setCounter] = useState(1);
  // const [pagination] = useState({
  //   start: 0,
  //   end: 10,
  // });

  // const EndValue = counter * pagination.end;
  // const StartValue = EndValue - pagination.end;
  // console.log(StartValue, EndValue);
  //   const Submit = async (val) => {
  //     try {

  //       axios
  //         .post("/Category", val)
  //         .then((res) => {
  //           if (res.status === 200) {
  //             toast.success("Category has been added sucessfully");
  //           }
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //         });
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };
  // let Spinner;
  //   if (progressShow) {
  //     Spinner = (
  //       <div
  //         style={{ background: "rgba(0,0,0,.5)" }}
  //         className="fixed h-screen w-screen top-0 left-0 z-50 flex items-center justify-center"
  //       >
  //         <div className="h-44 w-44  rounded-md z-50">
  //           <CircularProgressbar value={progress} text={`${progress}%`} />
  //         </div>
  //       </div>
  //     );
  //   }
  // const Submit = () => {
  //   console.log("first");
  // };

  //   const DeleteItems = (i) => {
  //     let removeItems = storeData;
  //     removeItems.splice(i, 1);
  //     setStoreData([...removeItems]);
  //     setMessage(false);
  //   };
  // const DeleteItems = () => {
  //   console.log("delete");
  // };
  // const Conformation = (id) => {
  //   setMessage(true);
  //   // setIdStore(id);
  //   // console.log(id);
  // };

  // let ConformationMessage;
  // if (message) {
  //   ConformationMessage = (
  //     <MasterDeleteModal
  //       // id={idStore}
  //       Delete={DeleteItems}
  //       setMessage={setMessage}
  //     />
  //   );
  // }

  const [storeValue, setStoreValue] = useState("bank");

  const data = [
    {
      title: "bank",
      type: "radio",
      apikey: "paymentMethod",
      value: "bank",
    },
    {
      title: "usdt",
      type: "radio",
      apikey: "paymentMethod",
      value: "usdt",
    },
  ];
  const handleDataClick = () => {
    let mod;
    switch (storeValue) {
      case "bank":
        mod = <WithdrawBankTable />;
        break;
      case "usdt":
        mod = <WithdrawUSDTTable />;
        break;
      default:
        break;
    }
    return mod;
  };
  return (
    <ContextApi>
      <div className=" col-span-8  w-full   ">
        <div className=" flex  gap-4 mt-5 px-8">
          {data.map((btn, index) => {
            return (
              <div key={index} className="flex gap-2   font-bold uppercase">
                <div
                  className={`w-6 h-6 rounded-full cursor-pointer  ${
                    storeValue === btn.title
                      ? "border-2 border-[#833cdc]"
                      : "null"
                  } flex items-center justify-center  `}
                  onClick={() => setStoreValue(btn.title)}
                >
                  <div
                    className={`w-3 h-3 rounded-full ${
                      storeValue === btn.title
                        ? "  bg-[#833cdc]  "
                        : "bg-[#833cdc]"
                    }`}
                  ></div>
                  {/* <input
                        type={btn.type}
                        name={btn.apikey}
                        value={btn.value}
                        checked={storeValue === btn.value}
                        onChange={(e) => setStoreValue(e.target.value)}
                        className={`text-blue-500 w-5 h-5 focus:ring-blue-500 ${
                          storeValue === btn.value ? "checked-radio  " : ""
                        }`}
                      /> */}
                </div>
                <div className="">{btn.title}</div>
              </div>
            );
          })}
        </div>
        {/* {console.log(storeValue)} */}
        <div className="">{handleDataClick()}</div>
      </div>
    </ContextApi>
  );
}

export default WithDrawReport;
